import { builderClient } from "./builder"
import { renderToString } from "react-dom/server";
import { getServerState } from "react-instantsearch";
import { Provider } from "react-redux";
import store from "@/redux/store";
import Collection from "@/components/PLP-2.0/collection";
import { collectionPath, getCollectionName } from "../components/PLP-2.0/collection-utils";
import { reportError } from "@/helpers/errorHelper";
import { getStore } from "@netlify/blobs";

//fetches the server state for [...pages] file
export const fetchCachedServerState = async (serverUrl, serverPath, isMobile) => {
  try{
    let path = `${serverPath}plpserverstate`;
    let storeCache= getStore("olivela-cache");
    const cache = await storeCache.getWithMetadata(`builderCachePLP${path}`, {
      type: "json",
    });
    
    const noOfHoursForExpiry = 1;

    const isExpired =
      new Date(cache?.metadata?.creationDate) <
      new Date(Date.now() - 1000 * 60 * 60 * noOfHoursForExpiry);
    if (cache != null  && Object.keys(cache?.data).length !== 0 && !isExpired && path === cache?.metadata?.path) {
      return cache.data;
    }
    const serverState =   await getServerState(<Provider store={store}><Collection serverRender={true} isMobile={isMobile} serverUrl={serverUrl} serverPath={serverPath} /></Provider>, {
      renderToString,
    });

    if(Object.keys(serverState).length !== 0){
      await storeCache.setJSON(`builderCachePLP${path}`, serverState, {
        metadata: { creationDate: Date.now(), path: path },
      });
    }

    return serverState;
  } catch(error) {
    reportError(error.stack);
    return {}
  }
}

const normalizeServerPath = (serverPath) => {
  const url = new URL(`${process.env.NETLIFY_URL}${serverPath}`); // Use a dummy base URL to parse
  return url.pathname; // Only return the path, excluding query parameters
};

export const fetchServerState = async (serverUrl, serverPath, isMobile, offset, length, seoData, oliSearch) => {
  try{
    // Parse the query parameters from the serverPath
    const url = new URL(`${process.env.NETLIFY_URL}${serverPath}`);
    const queryParams = Array.from(url.searchParams.keys());

    // Check if the query parameters include "products" or "page"
    const hasDynamicQueryParams = queryParams.some(param => param.startsWith("products") || param === "page" || param === "query");

    if (hasDynamicQueryParams) {
      // Fetch fresh data without caching
      return await getServerState(
        <Provider store={store}>
          <Collection
            serverRender={true}
            serverUrl={serverUrl}
            serverPath={serverPath}
            isMobile={isMobile}
            offset={offset}
            length={length}
            seoDataa={seoData}
            oliSearch={oliSearch}
          />
        </Provider>,
        {
          renderToString,
        }
      );
    }

    // Determine the device type
    const deviceType = isMobile ? "mobile" : "desktop";
    let path = `${normalizeServerPath(serverPath)}_${deviceType}_plpserverstate`;
    let storeCache= getStore("olivela-cache");
    const cache = await storeCache?.getWithMetadata(`builderCachePLP${path}`, {
      type: "json",
    });
    
    const noOfHoursForExpiry = 1;

    const isExpired =
      new Date(cache?.metadata?.creationDate) <
      new Date(Date.now() - 1000 * 60 * 60 * noOfHoursForExpiry);
    if (cache != null  && Object.keys(cache?.data).length !== 0 && !isExpired && path === cache?.metadata?.path) {
      return cache.data;
    }
    const serverState = await getServerState(
      <Provider store={store}>
        <Collection
          serverRender={true}
          serverUrl={serverUrl}
          serverPath={serverPath}
          isMobile={isMobile}
          offset={offset}
          length={length}
          seoDataa={seoData}
          oliSearch={oliSearch}
        />
      </Provider>,
      {
        renderToString,
      }
    );

    if(Object.keys(serverState)?.length !== 0){
      await storeCache?.setJSON(`builderCachePLP${path}`, serverState, {
        metadata: { creationDate: Date.now(), path: path },
      });
    }

    return serverState;
  } catch(error) {
    reportError(error.stack);
    return {}
  }
};

// export const fetchServerState = async (serverUrl, serverPath, isMobile, offset, length, seoData, oliSearch) => {
//   return await getServerState(<Provider store={store}><Collection serverRender={true} serverUrl={serverUrl} serverPath={serverPath} isMobile={isMobile} offset={offset} length={length} seoDataa={seoData} oliSearch={oliSearch}/></Provider>, {
//     renderToString,
//   });
// }

// checks if the given URL is a static page
export const isCurrentPageStatic = async (pageURL) => {
  /* Previously used on [..pages] file. Not require as of now. Keeping this as code backup. */
  /* Get pages list from builder to run on domain/{path}. If we found it from builder array then we consider this as static page. */
  try{
    const staticPagesList = []
  const allPages = await builderClient.getAll("page", {
    fields: pageURL,
    options: { noTargeting: true },
  });
  allPages.forEach((page) => {
    if (page.data?.url !== "/") {
      staticPagesList.push(`${page.data?.url}`);
    }
  });

  if (!staticPagesList.includes(pageURL)) {
    return false;
  }
  return true;
  } catch(error){
    reportError(error.stack);
    return {}
  }
}

// checks if the given URL belongs to any valid collection path or not
export const isValidCollection = (pageURL) => {
  pageURL = pageURL.split('?')[0];
  pageURL = pageURL.split("/");

  pageURL = pageURL.filter(item => item != '');
  // check for the valid collection for eg: /women
  var type = collectionPath.includes(pageURL[0])
  if (collectionPath.includes(pageURL[0])) {
    if (pageURL.length === 1 && pageURL[0] === 'designer') {
      /* For /designer we need to render builder page */
      return false;
    }
    return true
  }
  return false
  // check for the valid collection for eg: /women
  var type = collectionPath.includes(pageURL[0])
  //   eg: /beauty
  var level0Category = Object.keys(getCollectionName).includes(pageURL[0]);
  // eg: /women /clothing
  var level1Category = Object.keys(getCollectionName).includes(pageURL[1])
  // search page
  if (pageURL[0].includes("search")) {
    return true;
  }
  // url contains only /collection
  else if (pageURL.length === 1 && pageURL[0].includes("collection")) {
    return false;
  }
  else if (type || level0Category) {
    // check for valid level1 collection, eg: women/clothing1234 return 404 page
    if (pageURL[0] !== "designer" && pageURL[0] !== "collection" && pageURL.length >= 2 && !level1Category) {
      return false;
    }
    //  static designer page
    else if (pageURL.length === 1 && pageURL[0] === "designer") {
      return false;
    }
    else {
      return true;
    }
  }
  return false;
};

// fetches the builder content of the given page URL
export const fetchBuilderContent = async (isImpactOrCharityPage, pageURL,model) => {
  try{
    const builderContent =  await builderClient
    .get("menu", {
      userAttributes: {
        urlPath: isImpactOrCharityPage ? "/impact" : pageURL,
        impactOrCharityPage: isImpactOrCharityPage,
      },
    })
    .promise() || {}

    return builderContent;
  } catch(error) {
    reportError(error.stack);
    return {}
  }
}
// export const fetchBuilderContent = async (isImpactOrCharityPage, pageURL) => {
//   try{
//     return await builderClient
//     .get("menu", {
//       userAttributes: {
//         urlPath: isImpactOrCharityPage ? "/impact" : pageURL,
//         impactOrCharityPage: isImpactOrCharityPage,
//       },
//     })
//     .promise() || {}
//   } catch(error) {
//     reportError(error.stack);
//     return {}
//   }
// }

export const fetchBuilderContentModel = async (pageURL, model,app=false) => {

  try{
    return await builderClient
    .get(model, {
      userAttributes: {
        urlPath: pageURL,
        app: app
      },
    })
    .promise() || {};
  } catch(error) {
    reportError(error.stack);
    return {}
  }
}

// fetches the builder pages by the given page URL
export const fetchPagesByURL = async (pageURL,fullPageURL) => {
  try {
    const builderContent = await builderClient
    .get("page", {
      userAttributes: {
        urlPath: pageURL
      },
    })
    .toPromise() || null
    
    return builderContent;
  } catch (error) {
    console.log(error);
    reportError(error.stack);
    return {}
  }
}

// fetches the SEO info of the given page
export const fetchPageSEOData = (page) => {
  try{
    let pageTitle = "";
  let seoPageTitle = "";
  let seoDescription = "";

  if (
    page != undefined &&
    page.data != undefined &&
    page.data.pageTitle != undefined
  ) {
    pageTitle = page.data.pageTitle;
    seoPageTitle =
      page.data.seoPageTitle === undefined ||
        page.data.seoPageTitle === null ||
        page.data.seoPageTitle.trim() == ""
        ? pageTitle
        : page.data.seoPageTitle;
    seoDescription =
      page.data.seoDescription === undefined ||
        page.data.seoDescription === null ||
        page.data.seoDescription.trim() == ""
        ? pageTitle
        : page.data.seoDescription;
  }

  return { pageTitle, seoPageTitle, seoDescription } || {}
  } catch(error) {
    reportError(error.stack);
    return {}
  }
}

export const getShopifyIndexByServerPath = (serverPath) => {
  if(serverPath.includes("new-arrivals")){
    return process.env.SHOPIFY_NEWEST_FIRST_INDEX;
  }
  else{
    return process.env.SHOPIFY_PRIMARY_INDEX;
  }
}
